export default __webpack_public_path__ + "static/media/vehicle.a14e7a56cb48b4b869aea1f6fc95ef5e.svg";